import { Pipe } from '@angular/core';
import { CalendarEventTitleFormatter } from '../providers/calendarEventTitleFormatter.provider';
var CalendarEventTitlePipe = (function () {
    function CalendarEventTitlePipe(calendarEventTitle) {
        this.calendarEventTitle = calendarEventTitle;
    }
    CalendarEventTitlePipe.prototype.transform = function (title, titleType, event) {
        return this.calendarEventTitle[titleType](event);
    };
    CalendarEventTitlePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'calendarEventTitle'
                },] },
    ];
    /** @nocollapse */
    CalendarEventTitlePipe.ctorParameters = function () { return [
        { type: CalendarEventTitleFormatter, },
    ]; };
    return CalendarEventTitlePipe;
}());
export { CalendarEventTitlePipe };
//# sourceMappingURL=calendarEventTitle.pipe.js.map


//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/angular-calendar/dist/esm/src/pipes/calendarEventTitle.pipe.js
// module id = ../../../../angular-calendar/dist/esm/src/pipes/calendarEventTitle.pipe.js
// module chunks = 3